const stats = [
  { value: "6+", label: "聚合线路源" },
  { value: "秒切", label: "备用线路切换" },
  { value: "99%", label: "自动优选源" },
  { value: "24h", label: "稳定在线" },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20anime%20style%20illustration%20of%20a%20young%20hero%20watching%20the%20night%20sky%20with%20glowing%20screens%20and%20floating%20light%20streams%2C%20warm%20coral%20orange%20and%20teal%20color%20palette%2C%20dark%20moody%20background%2C%20dreamy%20atmosphere%2C%20high%20detail%20digital%20art%2C%20energetic%20and%20youthful&width=1600&height=900&seq=hero-kf-2026&orientation=landscape"
          alt="小猴看番多线路播放聚合场景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-background-50"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-6xl flex-col items-center px-4 pt-32 pb-20 text-center md:pt-40 md:pb-28">
        <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-sm text-white backdrop-blur">
          <span className="flex h-2 w-2 items-center justify-center">
            <span className="h-2 w-2 rounded-full bg-accent-400"></span>
          </span>
          多源播放 · 自动选源 · 备用线路秒切
        </span>

        <h1 className="mt-6 font-heading text-3xl leading-tight text-white md:text-5xl">
          追番不卡顿，
          <span className="text-accent-300">线路</span>随心切换
        </h1>

        <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/85 md:text-lg">
          小猴看番聚合多线路播放源，遇到线路卡顿一键秒切备用线路。
          多源播放自动选源，帮你快速找到流畅线路，追番不等待。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a
            href="#how"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            开始使用
          </a>
          <a
            href="#features"
            className="whitespace-nowrap rounded-md border border-white/40 bg-white/5 px-6 py-3 text-sm font-medium text-white backdrop-blur transition-colors hover:bg-white/15"
          >
            了解核心能力
          </a>
        </div>

        <dl className="mt-12 grid w-full grid-cols-2 gap-3 md:grid-cols-4 md:gap-5">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-lg border border-white/15 bg-white/5 p-4 backdrop-blur"
            >
              <dt className="sr-only">{s.label}</dt>
              <dd className="font-heading text-2xl text-white md:text-3xl">{s.value}</dd>
              <dd className="mt-1 text-xs text-white/75 md:text-sm">{s.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}